import { faBox, faCircleArrowUp, faUsers } from '@fortawesome/pro-thin-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as GivebutterPlusSplash from 'components/givebutter-plus-splash/GivebutterPlusSplash';
import TasksSplash from 'images/tasks-splash.webp';

const TasksGivebutterPlusSplashPage = () => {
    return (
        <GivebutterPlusSplash.Root>
            <GivebutterPlusSplash.Content>
                <GivebutterPlusSplash.Header>
                    <GivebutterPlusSplash.Text>
                        <GivebutterPlusSplash.HeaderLogo />
                        <GivebutterPlusSplash.Title>Tasks</GivebutterPlusSplash.Title>
                        <GivebutterPlusSplash.Description>
                            Organize and track your daily tasks with ease. Stay productive and
                            organized effortlessly, ensuring you and your team stays on top of
                            responsibilities and priorities.
                        </GivebutterPlusSplash.Description>
                        <GivebutterPlusSplash.CallToAction />
                    </GivebutterPlusSplash.Text>
                    <GivebutterPlusSplash.HeaderImage className="max-w-[31rem]">
                        <img src={TasksSplash} alt="Tasks illustration" />
                    </GivebutterPlusSplash.HeaderImage>
                </GivebutterPlusSplash.Header>
                <GivebutterPlusSplash.FeatureCardRow>
                    <GivebutterPlusSplash.FeatureCard>
                        <GivebutterPlusSplash.FeatureCardIcon className="bg-gbp-gradient-1">
                            <FontAwesomeIcon icon={faBox} size="xl" />
                        </GivebutterPlusSplash.FeatureCardIcon>
                        <GivebutterPlusSplash.FeatureCardText>
                            <GivebutterPlusSplash.FeatureCardTextHeading>
                                Organize & track
                            </GivebutterPlusSplash.FeatureCardTextHeading>
                            <GivebutterPlusSplash.FeatureCardTextDescription>
                                Create to-do lists, manage daily tasks, and ensure nothing falls
                                through the cracks.
                            </GivebutterPlusSplash.FeatureCardTextDescription>
                        </GivebutterPlusSplash.FeatureCardText>
                    </GivebutterPlusSplash.FeatureCard>

                    <GivebutterPlusSplash.FeatureCard>
                        <GivebutterPlusSplash.FeatureCardIcon className="bg-gbp-gradient-2">
                            <FontAwesomeIcon icon={faCircleArrowUp} size="xl" />
                        </GivebutterPlusSplash.FeatureCardIcon>
                        <GivebutterPlusSplash.FeatureCardText>
                            <GivebutterPlusSplash.FeatureCardTextHeading>
                                Enhance productivity
                            </GivebutterPlusSplash.FeatureCardTextHeading>
                            <GivebutterPlusSplash.FeatureCardTextDescription>
                                Organize tasks and schedule reminders, allowing you and your team to
                                focus what really matters
                            </GivebutterPlusSplash.FeatureCardTextDescription>
                        </GivebutterPlusSplash.FeatureCardText>
                    </GivebutterPlusSplash.FeatureCard>

                    <GivebutterPlusSplash.FeatureCard>
                        <GivebutterPlusSplash.FeatureCardIcon className="bg-gbp-gradient-3">
                            <FontAwesomeIcon icon={faUsers} size="xl" />
                        </GivebutterPlusSplash.FeatureCardIcon>
                        <GivebutterPlusSplash.FeatureCardText>
                            <GivebutterPlusSplash.FeatureCardTextHeading>
                                Improve accountability
                            </GivebutterPlusSplash.FeatureCardTextHeading>
                            <GivebutterPlusSplash.FeatureCardTextDescription>
                                Assign tasks and track their progression within the team, leading to
                                more efficient project management.
                            </GivebutterPlusSplash.FeatureCardTextDescription>
                        </GivebutterPlusSplash.FeatureCardText>
                    </GivebutterPlusSplash.FeatureCard>
                </GivebutterPlusSplash.FeatureCardRow>
                <GivebutterPlusSplash.Footer />
            </GivebutterPlusSplash.Content>
        </GivebutterPlusSplash.Root>
    );
};

export { TasksGivebutterPlusSplashPage };
